import { Button, Popconfirm, Tag } from 'antd';
import type { CustomerView } from '../customers.api';

interface CustomerStatusControlProps {
  customer: Pick<CustomerView, 'name' | 'isActive'>;
  canManage: boolean;
  onActivate: () => Promise<void>;
  onDeactivate: () => Promise<void>;
}

/** Deactivating a customer affects billing and dispatch elsewhere, so it asks first — same weight CLAUDE.md gives closing out a trip. */
export function CustomerStatusControl({ customer, canManage, onActivate, onDeactivate }: CustomerStatusControlProps) {
  if (!canManage) return <Tag color={customer.isActive ? 'success' : 'default'}>{customer.isActive ? 'Active' : 'Inactive'}</Tag>;

  if (customer.isActive) {
    return (
      <Popconfirm title={`Deactivate ${customer.name}?`} description="Review open trips and invoicing for this customer first." onConfirm={onDeactivate}>
        <Button danger>Deactivate</Button>
      </Popconfirm>
    );
  }

  return (
    <Popconfirm title={`Reactivate ${customer.name}?`} onConfirm={onActivate}>
      <Button>Activate</Button>
    </Popconfirm>
  );
}
